/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：JPI0
 */

// removed by extract-text-webpack-plugin
module.exports = {
  "dialog": "dialog_TTaOC",
  "dialogButtons": "dialogButtons_1qXlG",
  "dialogSecondary": "dialogSecondary_2xQWr",
  "denyButton": "denyButton_EK65c"
}

/***/
